import { useState } from "react";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";
import { ABUSE_REASON } from "../../lib/labels";

export default function ReportDialog({ onSubmit, onClose, testId = "report" }) {
  const [reason, setReason] = useState("spam");
  const [details, setDetails] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async () => { setBusy(true); await onSubmit({ reason, details }); setBusy(false); };
  return (
    <Dialog open onOpenChange={(o) => { if (!o) { onClose(); } }}>
      <DialogContent data-testid={`${testId}-dialog`}>
        <DialogHeader><DialogTitle>Signaler un abus</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-500">Le signalement est examiné par la modération VOXA AFRIKA. Un avis n'est jamais retiré simplement parce qu'il est négatif.</p>
        <select className="field-select" value={reason} onChange={(e) => setReason(e.target.value)} data-testid={`${testId}-reason-select`}>
          {Object.entries(ABUSE_REASON).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
        </select>
        <Textarea rows={3} maxLength={1000} value={details} onChange={(e) => setDetails(e.target.value)} placeholder="Précisions (facultatif)" data-testid={`${testId}-details-input`} />
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid={`${testId}-cancel`}>Annuler</Button>
          <Button onClick={submit} disabled={busy} data-testid={`${testId}-submit`}>{busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Envoyer le signalement</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
